import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface UseStylesProps {
  isExpanded?: boolean;
}

export const useStyles = ({ isExpanded }: UseStylesProps = {}) =>
  ({
    ccExpirySingleAccordionContainer: {
      marginRight: "4px",
      borderBottom: `1px ${colors.gray200} solid`,
      transition: "background-color 0.3s ease",
      cursor: "pointer",

      ":hover": {
        backgroundColor: isExpanded ? undefined : colors.gray50
      },

      "&.MuiAccordion-root:before": {
        backgroundColor: "transparent",
        border: "none"
      },

      "&.MuiAccordion-root:last-of-type": {
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0"
      },

      "& .MuiAccordionSummary-root": {
        padding: "12px 8px 8px 8px",
        borderBottomColor: "transparent !important"
      },

      "& .MuiAccordionSummary-content": {
        margin: "0"
      },

      "& .MuiAccordionDetails-root": {
        padding: "0 8px 16px 8px"
      }
    },

    accordionItem: {
      display: "flex",
      flexDirection: "column",
      padding: "8px",
      ":hover": {
        backgroundColor: colors.gray50,
        cursor: "pointer"
      }
    },

    accordionItemTitle: { display: "flex", alignItems: "center" },

    expirationBadge: { display: "flex", alignItems: "center", gap: "8px" },

    companyName: {
      color: colors.textSecondary,
      width: "fit-content",
      paddingLeft: "16px"
    }
  }) as CSSObject;
